@if (form) {
  <form
    [formGroup]="form"
    class="panel-flex"
    (validSubmit)="generateReport($event)"
  >
    <div class="panel-body form-section">
      <app-form-control appValidationContext size="full" [columnLayout]="true">
        <app-form-label> Report Type </app-form-label>
        <select
          data-dd-action-name="generate-consolidated-report.report-type-select"
          appFormControl
          formControlName="reportType"
        >
          <option value="">Select&hellip;</option>
          @for (reportType of ConsolidatedReportTypes; track reportType) {
            <option [ngValue]="reportType">
              {{ reportType }}
            </option>
          }
        </select>
        <div *invalidMessageFor="'required'">Report Type is required</div>
      </app-form-control>

      @if (filteredRegimes?.length !== 0) {
        <app-form-control [columnLayout]="true">
          <app-form-label> Regime </app-form-label>
          @if (filteredRegimes?.length !== 1) {
            <select
              data-dd-action-name="generate-consolidated-report.regime-select"
              appFormControl
              formControlName="regimeId"
            >
              @for (regime of regimes; track regime) {
                <option [ngValue]="regime.id">
                  {{ regime.name }}
                </option>
              }
            </select>
          } @else {
            <div class="form-control-plaintext">
              {{ filteredRegimes![0].name }}
            </div>
          }
        </app-form-control>
      }

      <ng-template #StartDate>
        <app-form-control [columnLayout]="true" appValidationContext>
          <app-form-label> Start Date </app-form-label>
          @if (!limitStartDate) {
            <app-period-selector
              appValidationContext
              formControlName="periodStartDate"
              [registerId]="firstSelectedRegister.id"
              [regimeId]="form.value.regimeId"
              [yearsBefore]="20"
            >
              <div *invalidMessageFor="'required'">Start Date is required</div>
              <div *invalidMessageFor="'maxDate' as error">
                Start Date must not be after {{ error.maxDate | aadate }}
              </div>
            </app-period-selector>
          } @else {
            <app-fin-year-selector
              formControlName="periodStartDate"
              [financialYearStart]="financialYearStart"
              [registerId]="firstSelectedRegister.id"
              [startDate]="firstYearStartDate"
              [regimeId]="form.controls.regimeId.value"
            >
              <div *invalidMessageFor="'required'">Start Date is required</div>
            </app-fin-year-selector>
          }
        </app-form-control>
      </ng-template>

      @switch (dateType) {
        @case ('START') {
          <ng-container *ngTemplateOutlet="StartDate"></ng-container>
        }

        @case ('DURATION') {
          <app-form-control [columnLayout]="true">
            <app-form-label> Duration </app-form-label>
            @if (durations?.length !== 1) {
              <select
                data-dd-action-name="generate-consolidated-report.duration-select"
                appFormControl
                formControlName="durationInYears"
              >
                @for (duration of durations; track duration) {
                  <option [ngValue]="duration.value">
                    {{ duration.label }}
                    @if (!duration.pdfAvailable) {
                      (CSV only)
                    }
                  </option>
                }
              </select>
            } @else {
              <div class="form-control-plaintext">
                {{ durations![0].label }}
              </div>
            }
          </app-form-control>

          <ng-container *ngTemplateOutlet="StartDate"></ng-container>
        }

        @case ('RANGE') {
          <ng-container *ngTemplateOutlet="StartDate"></ng-container>

          <app-form-control [columnLayout]="true">
            <app-form-label> End Date </app-form-label>
            <app-period-selector
              appValidationContext
              formControlName="periodEndDate"
              [registerId]="firstSelectedRegister.id"
              [regimeId]="form.value.regimeId"
              [minDate]="form.value.periodStartDate"
              [useEndDate]="true"
              [yearsBefore]="20"
            >
              <div *invalidMessageFor="'required'">End Date is required</div>
              <div *invalidMessageFor="'minDate'">
                End Date must be after Start Date
              </div>
              <div *invalidMessageFor="'maxDate' as error">
                End Date must not be after {{ error.maxDate | aadate }}
              </div>
            </app-period-selector>
          </app-form-control>
        }
      }

      <app-form-control [columnLayout]="true">
        <app-form-label> Format </app-form-label>
        @if (!isForcedFormat) {
          <select
            data-dd-action-name="generate-consolidated-report.format-select"
            appFormControl
            formControlName="format"
          >
            <option [ngValue]="ReportFormat.Pdf">PDF</option>
            <option [ngValue]="ReportFormat.Csv">CSV</option>
          </select>
        } @else {
          <div class="form-control-plaintext">CSV</div>
        }
      </app-form-control>

      @if (shouldShowConsolidationActions) {
        <app-form-control [columnLayout]="true">
          <app-form-label> Consolidation Action </app-form-label>
          <select
            data-dd-action-name="generate-consolidated-report.consolidation-action-select"
            appFormControl
            formControlName="consolidationAction"
          >
            <option [ngValue]="ReportConsolidationAction.Merge">
              Merge - Combine into a single report
            </option>
            <option [ngValue]="ReportConsolidationAction.Zip">
              Zip - Individual reports in a zip file
            </option>
          </select>
        </app-form-control>
      }
      @if (shouldShowIncludeAdditionalDisposalInfo) {
        <app-form-control [columnLayout]="true">
          <app-form-label>
            Include Additional Disposal Information
          </app-form-label>
          <div class="form-check">
            <input
              data-dd-action-name="generate-consolidated-report.include-additional-disposal-info-checkbox"
              class="form-check-input"
              type="checkbox"
              appFormControl
              formControlName="includeAdditionalDisposalInfo"
            />
          </div>
        </app-form-control>
      }
    </div>

    <div class="panel-footer d-flex justify-content-end">
      <button
        data-dd-action-name="generate-consolidated-report.cancel-button"
        type="button"
        class="btn btn-outline"
        (click)="onClose()"
      >
        Cancel
      </button>

      <button
        data-dd-action-name="generate-consolidated-report.generate-button"
        type="submit"
        class="btn btn-primary ms-2"
        [disabled]="form.disabled"
      >
        <i-lucide name="download"></i-lucide>
        Generate
      </button>
    </div>
  </form>
}
